import { foundationSegmentedControlStyles } from '@genesislcap/foundation-ui';
import { neutralFillStealthRest } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common/colors.hex';
export const zeroSegmentedControlStyles = (context, definition) => css `
  ${foundationSegmentedControlStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  :host ::slotted(*) {
    transition: color 0.4s ease 0s;
  }

  :host ::slotted(zero-segmented-item:first-of-type) {
    border-radius: calc(var(--control-corner-radius) * 1px) 0 0
      calc(var(--control-corner-radius) * 1px);
    border-right-width: 0;
  }

  :host ::slotted(zero-segmented-item:last-of-type) {
    border-radius: 0 calc(var(--control-corner-radius) * 1px)
      calc(var(--control-corner-radius) * 1px) 0;
    border-left-width: 0;
  }

  :host ::slotted(*[aria-checked='true']) {
    background: ${neutralFillStealthRest};
    background-origin: border-box;
    border-color: transparent;
    box-shadow: 2px 1000px 1px rgb(0 0 0 / 50%) inset;
  }

  :host([appearance='primary']) ::slotted(*[aria-checked='true']) {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    background-origin: border-box;
    border-color: transparent;
    box-shadow: 2px 1000px 1px rgb(0 0 0 / 50%) inset;
  }
`;
